// @module Digi.SupportDocs.SupportDocs
define('IMEIManager.List.View',
    [
        'imeimanager_list.tpl',
        'Backbone',
        'IMEIManager.Collection',
        'IMEIManager.Model',
        'IMEIManager.IMEI.View',
        'Backbone.CollectionView',
        'IMEIManager.Helper',
        'Profile.Model',
        'Utils'
    ],
    function (
        imeimanager_list_tpl,
        Backbone,
        IMEIManagerCollection,
        IMEIManagerModel,
        IMEIManagerIMEIView,
        CollectionView,
        IMEIManagerHelper,
        ProfileModel,
        Utils
    ) {
        'use strict';

        // @class Digi.SupportDocs.SupportDocs.View @extends Backbone.View
        return Backbone.View.extend({
            template: imeimanager_list_tpl,

            initialize: function (options) {
                var self = this;
                var models = [];
                var itemOption;
                var imeis;

                this.pdp = options.container.getComponent('PDP');

                this.configuration = options.container.getComponent('Environment').getConfig('digiConfigSettings.digiIMEIManager');

                this.profileModel = ProfileModel.getInstance();

                this.itemInfo = this.pdp.getItemInfo();

                this.isLoggedIn = this.profileModel.get('isLoggedIn') === 'T';

                this.showManager = this.itemInfo.item.custitem_imei_required;

                this.models = [];

                this.collection = new IMEIManagerCollection(this.models);
                this.collection.on('add', this.updateItem, this);
                this.collection.on('remove', this.updateItem, this);

                if (this.itemInfo) {
                    itemOption = _.find(this.itemInfo.options, { cartOptionId: 'custcol_imei_list' });

                    if (itemOption) {
                        imeis = itemOption.value && itemOption.value.internalid ? itemOption.value.internalid : undefined;
                        if (imeis) {
                            imeis = imeis.split(',');
                            var self = this;

                            _.each(imeis, function (i) {

                                self.collection.add(new IMEIManagerModel({ imei: i }));
                            });
                        }
                    }
                }

                this.errorMessage = '';
                this.successMessage = '';
                this.hasError = false;
            },

            events: {
                'click [data-action="add-imei"]': 'addModel',
                'change [data-id="imei"]': 'addModel',
                'keypress [data-id="imei"]': 'submitOnEnter',

                'click [data-action="import-imei"]': 'importModel',
                'click button[data-action="remove"]': 'removeModel'

            },

            childViews:
            {
                'IMEIManager.Collection': function () {
                    return new CollectionView({
                        'childView': IMEIManagerIMEIView,
                        'collection': this.collection,
                        'viewsPerRow': 1
                    });
                }
            },

            submitOnEnter: function (e) {
                if (e.keyCode === 13) {
                    e.preventDefault(e);
                    $('[data-action="add-imei"]').click();
                }
            },

            updateItem: function updateItem(model, collection, context, n) {
                var self = this;
                var ioValue = '';
                var imeis = this.collection.toJSON();

                _.each(imeis, function (imei, key) {
                    imeis.length == key + 1 ? ioValue += imei.imei : ioValue += imei.imei + ',';
                });

                this.pdp.setQuantity(imeis.length)
                this.pdp.setOption('custcol_imei_list', ioValue);
            },

            removeModel: function removeModel(e) {
                e.preventDefault();

                var id = $(e.target).data('id');
                var models = this.collection.where({ imei: String(id) });

                this.successMessage = '';
                this.collection.remove(models)
                this.render();
            },

            isIMEI: function isIMEI(s) {
                var sum;
                var mul;
                var digit;
                var tp;
                var chk;
                var l;
                var i;
                var etal = /^[0-9]{15}$/;
                if (!etal.test(s))
                    return false;
                sum = 0; mul = 2; l = 14;
                for (i = 0; i < l; i++) {
                    digit = s.substring(l - i - 1, l - i);
                    tp = parseInt(digit, 10) * mul;
                    if (tp >= 10)
                        sum += (tp % 10) + 1;
                    else
                        sum += tp;
                    if (mul == 1)
                        mul++;
                    else
                        mul--;
                }

                chk = ((10 - (sum % 10)) % 10);
                if (chk != parseInt(s.substring(14, 15), 10))
                    return false;
                return true;

            },
            validateICCID: function validateICCID(value) {
                if (/[^0-9-\s]+/.test(value)) return false;

                var nCheck = 0, nDigit = 0, bEven = true;
                value = value.replace(/\D/g, "");

                for (var n = value.length - 1; n >= 0; n--) {
                    var cDigit = value.charAt(n),
                        nDigit = parseInt(cDigit, 10);

                    if (bEven) {
                        if ((nDigit *= 2) > 9) nDigit -= 9;
                    }

                    nCheck += nDigit;
                    bEven = !bEven;
                }
                return (1000 - nCheck) % 10;
            },
            addModel: function addModel(e) {
                var self = this;
                var modalView;
                var imeiValue;
                var isValid = true;
                var errorMessage;

                if (e.keypress && e.keyCode == 13) return;

                e.preventDefault();

                this.successMessage = '';
                imeiValue = $('[data-id="imei"').val().trim();
                if (imeiValue.length === 15) {
                    isValid = this.isIMEI(imeiValue);
                    if (!isValid) {
                        errorMessage = 'Invalid IMEI.'
                    }
                } else if (imeiValue.length === 20) {
                    isValid = true;//this.validateICCID(imeiValue);
                    if (!isValid) {
                        errorMessage = 'Invalid ICCID.'
                    }
                } else {
                    isValid = false;
                    errorMessage = 'Invalid IMEI/ICCID.'
                }

                if (isValid && this.collection.findWhere({ imei: imeiValue })) {
                    isValid = false;
                    errorMessage = 'IMEI/ICCID already exists in list.'
                }

                if (isValid) {
                    this.collection.add({ imei: imeiValue });
                    this.successMessage = Utils.translate('IMEI/ICCID Successfully Added');
                }

                this.hasError = !isValid;
                this.errorMessage = errorMessage;
                this.render()
            },

            importModel: function importModel(e) {
                var self = this;
                var savedIMEI;

                e.preventDefault();

                savedIMEI = IMEIManagerHelper.getIMEIs();

                if (savedIMEI.length === 0) {
                    this.hasError = true;
                    this.errorMessage = 'No IMEIs to import.'
                } else {
                    _.each(savedIMEI, function (imei) {
                        self.collection.add({ imei: imei });
                    });

                    IMEIManagerHelper.clearIMEIs();
                }

                this.render()
            },

            getContext: function getContext() {
                return {
                    showManager: this.showManager && this.isLoggedIn,
                    hasError: this.hasError,
                    errorMessage: this.errorMessage,
                    successMessage: this.successMessage,
                    emptyList: this.collection.length < 1,
                    imeiImportLabel: this.configuration.importBtnLabel,
                    imeiParagraph: this.configuration.pText
                }
            }
        });
    });
